const commonDrawJs = {

}
commonDrawJs.drawLine = function (ctx, line, color, lineWidth, lineDash) {
  if (ctx === null || line === null) {
    return
  }

  ctx.save()
  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.setLineDash(lineDash || [0])
  ctx.beginPath()
  ctx.moveTo(line.x1, line.y1)
  ctx.lineTo(line.x2, line.y2)
  ctx.stroke()
  ctx.restore()
}
commonDrawJs.drawLines = function (ctx, points, color, lineWidth, lineDash) {
  if (ctx === null || points === null || points.length === 0) {
    return
  }
  ctx.save()
  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.setLineDash(lineDash || [0])
  ctx.beginPath()
  ctx.moveTo(points[0].x, points[0].y)
  for (var i = 1; i < points.length; i++) {
    ctx.lineTo(points[i].x, points[i].y)
  }
  ctx.lineTo(points[0].x, points[0].y)
  ctx.stroke()
  ctx.restore()
}
commonDrawJs.drawCurveAreas = function (ctx, x, y, radius, startAngle, fillAngle, lineColor, fillColor, lineWidth) {
  if (ctx === null) {
    return
  }
  ctx.save()
  // 设置圆环的宽度
  ctx.lineWidth = lineWidth
  if (fillColor) {
    ctx.beginPath()
    ctx.arc(x, y, radius - lineWidth, startAngle * Math.PI / 180 - fillAngle / 2, startAngle * Math.PI / 180 + fillAngle / 2)
    ctx.fillStyle = fillColor
    ctx.closePath()
    ctx.fill()
  } else {
    ctx.beginPath()
    ctx.moveTo(0, 0)
    ctx.lineTo(0, y * 2)
    ctx.arc(x, y, radius, startAngle * Math.PI / 180 - fillAngle / 2, startAngle * Math.PI / 180 + fillAngle / 2)
    ctx.fillStyle = '#FFFFFF'
    ctx.strokeStyle = '#EAEAEA'
    ctx.closePath()
    ctx.stroke()
    ctx.fill()
  }
  ctx.beginPath()
  ctx.arc(x, y, radius, startAngle * Math.PI / 180 - fillAngle / 2, startAngle * Math.PI / 180 + fillAngle / 2)
  // 用渐变进行填充颜色
  ctx.strokeStyle = lineColor
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}
commonDrawJs.drawRect = function (ctx, x, y, width, height, color, fillColor, lineWidth, isFill) {
  if (ctx === null) {
    return
  }

  ctx.save()
  if (isFill) {
    ctx.fillStyle = fillColor
    ctx.fillRect(x, y, width, height)
  }
  ctx.lineWidth = lineWidth
  ctx.strokeStyle = color
  ctx.strokeRect(x, y, width, height)
  ctx.restore()
}
commonDrawJs.drawPath = function (ctx, points, color) {
  var i, p

  if (ctx === null || points === null) {
    return
  }

  ctx.save()
  ctx.beginPath()
  for (i = 0; i < points.length; i++) {
    p = points[i]
    ctx.lineTo(p.x, p.y)
  }
  ctx.closePath()
  ctx.fillStyle = color
  ctx.fill()
  ctx.restore()
}
commonDrawJs.drawText = function (ctx, text, x, y, color) {
  if (ctx === null) {
    return
  }

  ctx.save()
  ctx.font = '14px Arial'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'
  ctx.fillStyle = color
  ctx.fillText(text, x, y)
  ctx.restore()
}

/**
 * 图片上画文字
 */
commonDrawJs.drawTextRotate = function (ctx, text, x, y, color, angle) {
  ctx.save()
  ctx.font = '12px Arial'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'
  ctx.fillStyle = color
  ctx.translate((x), (y))
  ctx.rotate(angle * Math.PI / 180)
  ctx.translate(-x, -y)
  // ctx.rotate(0*Math.PI/180);
  ctx.fillText(text, x, y)
  ctx.restore()
}
/**
 * 画扇形凸面
 * p0表示圆心
 * p1、p2表示圆周上的点
 * p3表示圆上任意点
 * radian半径
 */
commonDrawJs.drawSector = function (p0, p1, p2, p3, radian, color, angle1, angle2, ctx) {
  color = 'rgba(251, 252, 148, 0.5)'
  // 画拱形
  ctx.beginPath()
  ctx.fillStyle = color
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)'
  ctx.lineWidth = 1
  ctx.arc(p0.x, p0.y, radian, angle1, angle2, false)
  ctx.fill()
  ctx.stroke()
  // 画3角
  ctx.beginPath()
  ctx.lineTo(p1.x, 0 - p1.y)
  ctx.lineTo(p3.x, 0 - p3.y)
  ctx.lineTo(p2.x, 0 - p2.y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

/**
 * 画扇形凹面
 * p0表示圆心
 * p1、p2表示圆周上的点
 * p3表示圆上任意点
 * radian半径
 */
commonDrawJs.drawSectorA = function (p0, p1, p2, p3, radian, color, angle1, angle2, ctx) {
  // var color = 'rgba(255, 255, 255, 1)'
  // 画3角
  ctx.beginPath()
  ctx.lineTo(p1.x, -p1.y)
  ctx.lineTo(p3.x, -p3.y)
  ctx.lineTo(p2.x, -p2.y)
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)'
  ctx.fillStyle = color
  ctx.fill()
  ctx.stroke()
  // 画拱形
  ctx.beginPath()
  ctx.fillStyle = '#FFFFFF'
  ctx.lineWidth = 1
  ctx.arc(p0.x, p0.y, radian, angle1, angle2, true)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

/**
 * 画投影仪
 */
commonDrawJs.drawMuProject = function (ctx, x, y, s, angle) {
  // let s = 3
  ctx.save()
  ctx.translate((x), (y))
  ctx.rotate((180 - angle) * Math.PI / 180)
  ctx.beginPath()
  ctx.moveTo(0, -s)
  ctx.lineTo(s, -s)
  ctx.lineTo(s, -3 * s)
  ctx.lineTo(8 * s, -3 * s)
  ctx.lineTo(8 * s, 3 * s)
  ctx.lineTo(s, 3 * s)
  ctx.lineTo(s, s)
  ctx.lineTo(0, s)
  ctx.lineTo(0, -s)
  ctx.strokeStyle = 'black'
  ctx.lineWidth = 1.5
  ctx.stroke()
  ctx.translate(-x, -y)
  ctx.restore()
}
/**
 *画弧线
 *x, y圆心坐标
 * radian半径
 * a0,a1角度范围
 */
commonDrawJs.drawArcLine = function (x, y, radian, color, a0, a1, lineWidth, ctx) {
  ctx.beginPath()
  // ctx.arc(500, 300, 180, a0, a1, true)
  ctx.arc(x, y, radian, a0, a1, true)
  ctx.strokeStyle = color
  ctx.lineWidth = lineWidth
  ctx.stroke()
  ctx.closePath()
}

/**
 * 画箭头
 */
commonDrawJs.drawArrowhead = function (ctx, locx, locy, angle, color, sizex, sizey) {
  var hx = sizex / 2 + sizex / 2
  var hy = sizey / 2
  ctx.save()
  ctx.translate((locx), (locy))
  ctx.rotate(angle)
  ctx.translate(-hx, -hy)

  ctx.beginPath()
  ctx.moveTo(0, 0)
  ctx.lineTo(0, 1 * sizey)
  ctx.lineTo(1 * sizex, 1 * hy)
  ctx.fillStyle = color
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

commonDrawJs.toPoint = (x, y) => {
  return {
    x: x,
    y: y
  }
}
commonDrawJs.toRect = (x, y, width, height) => {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  }
}
commonDrawJs.toRectArea = (x, y, width, height, lineColor, fillColor, lineWidth) => {
  return {
    x: x,
    y: y,
    width: width,
    height: height,
    lineColor: lineColor,
    fillColor: fillColor,
    lineWidth: lineWidth || 1
  }
}
commonDrawJs.toLine = (x1, y1, x2, y2, color, lineWidth) => {
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    color: color,
    lineWidth: lineWidth || 1
  }
}
commonDrawJs.toCurveArea = (x, y, radius, startAngle, fillAngle, lineColor, fillColor, lineWidth) => {
  return {
    x: x,
    y: y,
    radius: radius,
    startAngle: startAngle,
    fillAngle: fillAngle,
    lineColor: lineColor,
    fillColor: fillColor,
    lineWidth: lineWidth || 1
  }
}
commonDrawJs.toArrow = (x1, y1, x2, y2, x3, y3, color) => {
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    x3: x3,
    y3: y3,
    color: color
  }
}
commonDrawJs.toArrowHead = (x, y, angle, color) => {
  return {
    x: x,
    y: y,
    angle: angle,
    color: color
  }
}
commonDrawJs.toText = (x, y, text) => {
  return {
    text: text,
    x: x,
    y: y
  }
}
commonDrawJs.toArcText = (x, y, text, angle) => {
  return {
    text: text,
    x: x,
    y: y,
    angle: angle
  }
}
commonDrawJs.toSector = (p, radius) => {
  return {
    p: p,
    radius: radius
  }
}
commonDrawJs.toArcLine = (x, y, radian, color, a0, a1, lineWidth) => {
  return {
    x: x,
    y: y,
    radian: radian,
    color: color,
    a0: a0,
    a1: a1,
    lineWidth: lineWidth
  }
}
export default commonDrawJs



// WEBPACK FOOTER //
// ./src/common/commonDraw.js